import axios from "axios";
import config from "../config/config";
import { API_TIMEOUT } from "../assets/constants";

/**
 * Centralized axios instance for all API calls
 * - Automatically handles encoding via axios
 * - Provides consistent configuration across all services
 */
const apiClient = axios.create({
  baseURL: config.PCA_SERVER_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/**
 * Request interceptor - automatically injects userKey header
 */
apiClient.interceptors.request.use(
  (config) => {
    // Auto-inject userKey header from localStorage for all requests
    const userKey = localStorage.getItem("userKey");
    if (userKey && userKey !== "0" && userKey !== "undefined" && userKey !== "null") {
      config.headers["x-user-key"] = userKey;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor - standardizes error handling
 */
apiClient.interceptors.response.use(
  (response) => {
    // Return just the data for successful responses
    return response;
  },
  (error) => {
    // Standardize error format
    if (error.response) {
      // Server responded with error status
      const customError = new Error(error.response.statusText || "Request failed");
      customError.status = error.response.status;
      customError.data = error.response.data;
      throw customError;
    } else if (error.request) {
      // Request made but no response
      const customError = new Error("No response from server");
      customError.status = 0;
      throw customError;
    } else {
      // Something else happened
      throw error;
    }
  }
);

export default apiClient;
